import api from "../../../../api/axios"
import { ExpenseTimeline } from "../../../classes/employee"

const twoWeeksAgo = new Date().setHours(0, 0, 0, 0) - 1209600000

export default class Expenses {
	static async getExpenseTimelines() {
		const response = await api.get("expense/v2")

		const expenses = response?.data?.data.filter((expense) => {
			const { submittedTs, holdTs, deniedTs, allocations } = expense.expenseHistory

			if (holdTs) return holdTs > twoWeeksAgo
			else if (deniedTs) return deniedTs > twoWeeksAgo
			else if (submittedTs) {
				return allocations.some((allocation) => {
					const completedTs = allocation.completedTs
					const noFundsTs = allocation.noFundsTs
					return !noFundsTs && (!completedTs || completedTs > twoWeeksAgo)
				})
			}
		})

		const expenseTimelines = expenses.map((expense) => new ExpenseTimeline({ expense }))

		return expenseTimelines
	}
}
